import { render, staticRenderFns } from "./FishNewData.vue?vue&type=template&id=9a62de74"
import script from "./FishNewData.vue?vue&type=script&lang=js"
export * from "./FishNewData.vue?vue&type=script&lang=js"
import style0 from "./FishNewData.vue?vue&type=style&index=0&id=9a62de74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports